import { faList } from '@fortawesome/pro-solid-svg-icons'

import { EmptyState, FormattedMessage } from '@b-stock/fe-core/bstock-react'
import type { ManifestPivotRow } from '@b-stock/order-process-api-client'

export type PivotTableKey =
  | 'BRAND'
  | 'CATEGORY'
  | 'CONDITION'
  | 'MODEL'
  | 'SELLER_CATEGORY'
  | 'SELLER_GRADE'
  | 'SUBCATEGORY'

export const pivotTableKeyToField: Record<
  PivotTableKey,
  keyof ManifestPivotRow
> = {
  BRAND: 'brand',
  CATEGORY: 'category',
  CONDITION: 'condition',
  MODEL: 'model',
  SELLER_CATEGORY: 'sellerCategory',
  SELLER_GRADE: 'sellerGrade',
  SUBCATEGORY: 'subcategory',
}

export function isEmptyPivotTable(
  pivotTableKey: PivotTableKey,
  pivotData: Partial<ManifestPivotRow>[]
) {
  if (pivotData.length === 0) {
    return true
  }
  if (pivotData.length === 1) {
    // Safe: length check guarantees pivotData[0] exists
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const value = pivotData[0]![pivotTableKeyToField[pivotTableKey]]
    return !value || value === 'None'
  }
  return false
}

export const PivotTableEmptyState = ({
  pivotTableKey,
}: {
  pivotTableKey: PivotTableKey
}) => (
  <EmptyState
    size={2}
    icon={faList}
    maxWidthRem={40}
    description={
      <FormattedMessage
        id="Listing.manifestPivotTable.emptyState.description"
        values={{
          pivotTableKey: (
            <FormattedMessage
              id={`Listing.manifestPivotTable.pivotTableKey.${pivotTableKey}`}
              defaultMessage={pivotTableKey}
            />
          ),
        }}
      />
    }
  />
)
